<template>
  <CustomModal
    :visible="visible"
    title="Choose a meeting agent type"
    width="500px"
    @update:visible="updateVisibility"
  >
    <CustomSelector
      source="meeting_agent"
      :options="agentTypeOptions"
      v-model="selectedType"
    />
    <template #footer>
      <a-button class="primary_medium" @click="handleContinue"
        >Continue</a-button
      >
    </template>
  </CustomModal>
</template>

<script setup>
import { ref, watch } from "vue";
import CustomModal from "@/src/components/CustomModal.vue";
import CustomSelector from "@/src/components/CustomSelector.vue";

import { agentTypeOptions } from "@/src/constants/meetingAgentConstants.js";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:visible", "selected"]);

const selectedType = ref("One-on-One");

const updateVisibility = (value) => {
  emit("update:visible", value);
  if (!value) {
    selectedType.value = null;
  }
};

const handleContinue = () => {
  if (selectedType.value) {
    emit("selected", selectedType.value);
    updateVisibility(false);
  }
};

watch(
  () => props.visible,
  (newValue) => {
    if (!newValue) {
      selectedType.value = "One-on-One";
    }
  },
);
</script>
